export default "__VITE_ASSET__CVVQRkK2__"